// askSmart-ui/src/pages/MapleCoin/customerApi.ts
//
// The read-only MapleCoin customer API. The signed-in session (cookie) is the
// only identity sent: the server resolves the customer from the verified
// token, and an account number here only works for the caller's own account.
import { AccountOverview, AccountSummary, Customer, Transaction } from './types';

export class MapleCoinApiError extends Error {
  status: number;
  constructor(status: number) {
    super(`MapleCoin request failed (${status})`);
    this.name = 'MapleCoinApiError';
    this.status = status;
  }
}

async function get<T>(path: string): Promise<T> {
  const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/maplecoin/me${path}`, { credentials: 'include' });
  if (!res.ok) throw new MapleCoinApiError(res.status);
  return (await res.json()) as T;
}

export type MeResponse =
  | { onboarded: false }
  | { onboarded: true; customer: Customer; accounts: AccountSummary[] };

export const fetchMe = () => get<MeResponse>('');

export const fetchAccount = (accountNumber: string) =>
  get<AccountOverview>(`/accounts/${encodeURIComponent(accountNumber)}`);

export function fetchActivity(accountNumber: string, opts: { limit?: number; before?: string } = {}) {
  const q = new URLSearchParams();
  if (opts.limit) q.set('limit', String(opts.limit));
  if (opts.before) q.set('before', opts.before);
  const qs = q.toString();
  return get<{ accountNumber: string; transactions: Transaction[]; nextBefore: string | null }>(
    `/accounts/${encodeURIComponent(accountNumber)}/activity${qs ? `?${qs}` : ''}`,
  );
}
